import React, { useState, useCallback, useEffect } from 'react';
import DialogContent from '@mui/material/DialogContent';
import TextFieldWithClear from 'components/TextFieldWithIcon/TextFieldWithIcon';
import BaseForm from 'components/Inputs/Forms/BaseForm';
import CustomSelect from 'components/Inputs/Select/Select';

type InitialValues = {
  clientOrganizationId?: string;
  status?: string;
};

type Props = {
  onSubmit: Function;
  editMode?: boolean;
  initialValues?: InitialValues;
};

export default function PaperTrlIntegrationForm(props: Props) {
  const { editMode = false, initialValues = {} } = props;

  const [clientOrganizationId, setClientOrganizationId] = useState(
    initialValues.clientOrganizationId ?? '',
  );
  const [status, setStatus] = useState(initialValues.status ?? 'enabled');

  useEffect(() => {
    if (!initialValues) return;
    setClientOrganizationId(initialValues.clientOrganizationId ?? '');
    setStatus(initialValues.status ?? 'enabled');
  }, [initialValues?.clientOrganizationId, initialValues?.status]);

  const validateThenSubmit = useCallback(
    function () {
      const trimmedId = clientOrganizationId.trim();
      if (!trimmedId) {
        props.onSubmit({
          isValid: false,
          message: 'Missing Field(s): PaperTrl Organization ID.',
        });
        return;
      }
      props.onSubmit({
        isValid: true,
        data: { clientOrganizationId: trimmedId, status },
      });
    },
    [clientOrganizationId, status, editMode],
  );

  return (
    <DialogContent>
      <div>
        Enter the PaperTrl Organization ID provided for this company to enable
        PaperTrl SSO.
      </div>
      <BaseForm onSubmit={validateThenSubmit}>
        <TextFieldWithClear
          label="PaperTrl Organization ID"
          onChange={({ target: { value } }: any) =>
            setClientOrganizationId(value)
          }
          value={clientOrganizationId}
          onClear={() => setClientOrganizationId('')}
          margin="normal"
          variant="outlined"
        />
        <CustomSelect
          menuItems={[
            { value: 'enabled', label: 'Enabled' },
            { value: 'disabled', label: 'Disabled' },
          ]}
          label="Status"
          onChange={({ target: { value } }: any) => setStatus(value)}
          value={status}
          margin="normal"
          variant="outlined"
          fullWidth
        />
      </BaseForm>
    </DialogContent>
  );
}
